export default "__VITE_ASSET__d6FhA62t__"